import React from 'react'
import PropTypes from 'prop-types'

const NotYetSpecified = props => (
  <div className="not-yet-specified">
    <div
      className={`icon-circle-incomplete-light ${
        props.hideCircleIcon ? 'hidden' : ''
      }`}
    />
    <div className={props.textClass || 'text'}>Not Yet Specified</div>
  </div>
)

NotYetSpecified.propTypes = {
  hideCircleIcon: PropTypes.bool,
  textClass: PropTypes.string
}

export default NotYetSpecified



// WEBPACK FOOTER //
// ./src/components/mini/NotYetSpecified.js